// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { ColumnFindings, ListProjectsResponse, MiningPaginatedResponse, ProjectRelationshipsResponse, ProjectResponse, ProjectTableSummaryResponse, RelationshipForeignKey, TableFindingsResponse, TableHealthResponse, TableKnowledge, TableRelationships } from "../project/dto.generated";
import type { AddMemberResponse, LeavePreview, LeaveResult, ListWorkspaceMembersResponse, MemberIdpSubResponse, PendingWorkspaceInvitationResponse, UpdateMemberRoleResponse, WorkspaceMemberResponse } from "../workspace/dto.generated";
export const addTagTypes = ["projects", "mining", "mcp"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiProjectsByProjectId: build.query<
        GetApiProjectsByProjectIdApiResponse,
        GetApiProjectsByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}`,
        }),
        providesTags: ["projects"],
      }),
      deleteApiProjectsByProjectId: build.mutation<
        DeleteApiProjectsByProjectIdApiResponse,
        DeleteApiProjectsByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["projects"],
      }),
      postApiProjectsByProjectIdLeave: build.mutation<
        PostApiProjectsByProjectIdLeaveApiResponse,
        PostApiProjectsByProjectIdLeaveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/leave`,
          method: "POST",
          body: queryArg.workspaceLeaveRequest,
        }),
        invalidatesTags: ["projects"],
      }),
      getApiProjectsByProjectIdLeavePreview: build.query<
        GetApiProjectsByProjectIdLeavePreviewApiResponse,
        GetApiProjectsByProjectIdLeavePreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/leave-preview`,
        }),
        providesTags: ["projects"],
      }),
      getApiProjectsByProjectIdMembers: build.query<
        GetApiProjectsByProjectIdMembersApiResponse,
        GetApiProjectsByProjectIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members`,
        }),
        providesTags: ["projects"],
      }),
      postApiProjectsByProjectIdMembers: build.mutation<
        PostApiProjectsByProjectIdMembersApiResponse,
        PostApiProjectsByProjectIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members`,
          method: "POST",
          body: queryArg.workspaceAddMemberRequest,
        }),
        invalidatesTags: ["projects"],
      }),
      projectGetMembersIdpSubs: build.query<
        ProjectGetMembersIdpSubsApiResponse,
        ProjectGetMembersIdpSubsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members/idp-subs`,
        }),
        providesTags: ["projects"],
      }),
      getApiProjectsByProjectIdMembersInvitations: build.query<
        GetApiProjectsByProjectIdMembersInvitationsApiResponse,
        GetApiProjectsByProjectIdMembersInvitationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members/invitations`,
        }),
        providesTags: ["projects"],
      }),
      deleteApiProjectsByProjectIdMembersInvitationsAndInvitationId:
        build.mutation<
          DeleteApiProjectsByProjectIdMembersInvitationsAndInvitationIdApiResponse,
          DeleteApiProjectsByProjectIdMembersInvitationsAndInvitationIdApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members/invitations/${encodeURIComponent(String(queryArg.invitationId))}`,
            method: "DELETE",
          }),
          invalidatesTags: ["projects"],
        }),
      deleteApiProjectsByProjectIdMembersAndUserId: build.mutation<
        DeleteApiProjectsByProjectIdMembersAndUserIdApiResponse,
        DeleteApiProjectsByProjectIdMembersAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members/${encodeURIComponent(String(queryArg.userId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["projects"],
      }),
      patchApiProjectsByProjectIdMembersAndUserIdRole: build.mutation<
        PatchApiProjectsByProjectIdMembersAndUserIdRoleApiResponse,
        PatchApiProjectsByProjectIdMembersAndUserIdRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/members/${encodeURIComponent(String(queryArg.userId))}/role`,
          method: "PATCH",
          body: queryArg.workspaceUpdateWorkspaceMemberRoleRequest,
        }),
        invalidatesTags: ["projects"],
      }),
      getApiProjectsByProjectIdRelationships: build.query<
        GetApiProjectsByProjectIdRelationshipsApiResponse,
        GetApiProjectsByProjectIdRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/relationships`,
        }),
        providesTags: ["projects"],
      }),
      miningListAvailableTables: build.query<
        MiningListAvailableTablesApiResponse,
        MiningListAvailableTablesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/views`,
        }),
        providesTags: ["mining"],
      }),
      miningListAvailableTablesWithColumns: build.query<
        MiningListAvailableTablesWithColumnsApiResponse,
        MiningListAvailableTablesWithColumnsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/views/with-columns`,
        }),
        providesTags: ["mining"],
      }),
      miningListAvailableTablesWithMetadata: build.query<
        MiningListAvailableTablesWithMetadataApiResponse,
        MiningListAvailableTablesWithMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/views/with-metadata`,
        }),
        providesTags: ["mining"],
      }),
      miningShowTableSchema: build.query<
        MiningShowTableSchemaApiResponse,
        MiningShowTableSchemaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/views/${encodeURIComponent(String(queryArg.tableName))}`,
          params: {
            page: queryArg.page,
            executionId: queryArg.executionId,
          },
        }),
        providesTags: ["mining"],
      }),
      miningQueryTable: build.mutation<
        MiningQueryTableApiResponse,
        MiningQueryTableApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/views/${encodeURIComponent(String(queryArg.tableName))}/query`,
          method: "POST",
          body: queryArg.projectQueryTableRequest,
          params: {
            page: queryArg.page,
            executionId: queryArg.executionId,
            waitSeconds: queryArg.waitSeconds,
            count: queryArg.count,
          },
        }),
        invalidatesTags: ["mining"],
      }),
      getApiProjectsByProjectIdTablesAndTableNameFindings: build.query<
        GetApiProjectsByProjectIdTablesAndTableNameFindingsApiResponse,
        GetApiProjectsByProjectIdTablesAndTableNameFindingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/${encodeURIComponent(String(queryArg.tableName))}/findings`,
        }),
        providesTags: ["mcp"],
      }),
      getApiWorkspacesByIdProjects: build.query<
        GetApiWorkspacesByIdProjectsApiResponse,
        GetApiWorkspacesByIdProjectsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/projects`,
          params: {
            limit: queryArg.limit,
            cursor: queryArg.cursor,
            q: queryArg.q,
            include: queryArg.include,
          },
        }),
        providesTags: ["projects"],
      }),
      postApiWorkspacesByIdProjects: build.mutation<
        PostApiWorkspacesByIdProjectsApiResponse,
        PostApiWorkspacesByIdProjectsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/projects`,
          method: "POST",
          body: queryArg.projectCreateProjectRequest,
        }),
        invalidatesTags: ["projects"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as projectApi };
export type GetApiProjectsByProjectIdApiResponse =
  /** status 200 OK */ { data: ProjectProjectResponse };
export type GetApiProjectsByProjectIdApiArg = {
  /** Project ID */
  projectId: string;
};
export type DeleteApiProjectsByProjectIdApiResponse =
  /** status 200 OK */ { data: string };
export type DeleteApiProjectsByProjectIdApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdLeaveApiResponse =
  /** status 200 OK */ { data: WorkspaceLeaveResult };
export type PostApiProjectsByProjectIdLeaveApiArg = {
  /** Project ID */
  projectId: string;
  /** New workspace owner to hand ownership to */
  workspaceLeaveRequest: WorkspaceLeaveRequest;
};
export type GetApiProjectsByProjectIdLeavePreviewApiResponse =
  /** status 200 OK */ { data: WorkspaceLeavePreview };
export type GetApiProjectsByProjectIdLeavePreviewApiArg = {
  /** Project ID */
  projectId: string;
};
export type GetApiProjectsByProjectIdMembersApiResponse =
  /** status 200 OK */ { data: WorkspaceListWorkspaceMembersResponse };
export type GetApiProjectsByProjectIdMembersApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdMembersApiResponse =
  /** status 201 Created */ { data: WorkspaceAddMemberResponse };
export type PostApiProjectsByProjectIdMembersApiArg = {
  /** Project ID */
  projectId: string;
  /** Add member by email request */
  workspaceAddMemberRequest: WorkspaceAddMemberRequest;
};
export type ProjectGetMembersIdpSubsApiResponse =
  /** status 200 OK */ { data: WorkspaceMemberIdpSubResponse[] };
export type ProjectGetMembersIdpSubsApiArg = {
  /** Project ID */
  projectId: string;
};
export type GetApiProjectsByProjectIdMembersInvitationsApiResponse =
  /** status 200 OK */ { data: WorkspacePendingWorkspaceInvitationResponse[] };
export type GetApiProjectsByProjectIdMembersInvitationsApiArg = {
  /** Project ID */
  projectId: string;
};
export type DeleteApiProjectsByProjectIdMembersInvitationsAndInvitationIdApiResponse =
  unknown;
export type DeleteApiProjectsByProjectIdMembersInvitationsAndInvitationIdApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Invitation ID */
    invitationId: string;
  };
export type DeleteApiProjectsByProjectIdMembersAndUserIdApiResponse = unknown;
export type DeleteApiProjectsByProjectIdMembersAndUserIdApiArg = {
  /** Project ID */
  projectId: string;
  /** User ID */
  userId: string;
};
export type PatchApiProjectsByProjectIdMembersAndUserIdRoleApiResponse =
  /** status 200 OK */ { data: WorkspaceUpdateMemberRoleResponse };
export type PatchApiProjectsByProjectIdMembersAndUserIdRoleApiArg = {
  /** Project ID */
  projectId: string;
  /** User ID */
  userId: string;
  /** Update member role request */
  workspaceUpdateWorkspaceMemberRoleRequest: WorkspaceUpdateWorkspaceMemberRoleRequest;
};
export type GetApiProjectsByProjectIdRelationshipsApiResponse =
  /** status 200 OK */ { data: ProjectProjectRelationshipsResponse };
export type GetApiProjectsByProjectIdRelationshipsApiArg = {
  /** Project ID */
  projectId: string;
};
export type MiningListAvailableTablesApiResponse =
  /** status 200 OK */ string[];
export type MiningListAvailableTablesApiArg = {
  /** Project ID */
  projectId: string;
};
export type MiningListAvailableTablesWithColumnsApiResponse =
  /** status 200 OK */ {
    [key: string]: {
      [key: string]: string;
    };
  };
export type MiningListAvailableTablesWithColumnsApiArg = {
  /** Project ID */
  projectId: string;
};
export type MiningListAvailableTablesWithMetadataApiResponse =
  /** status 200 OK */ {
    [key: string]: AdaptersTableMetadata;
  };
export type MiningListAvailableTablesWithMetadataApiArg = {
  /** Project ID */
  projectId: string;
};
export type MiningShowTableSchemaApiResponse =
  /** status 200 OK */ ProjectMiningPaginatedResponse;
export type MiningShowTableSchemaApiArg = {
  /** Project ID */
  projectId: string;
  /** Table name */
  tableName: string;
  /** Page number */
  page?: number;
  /** Execution ID for pagination */
  executionId?: string;
};
export type MiningQueryTableApiResponse =
  /** status 200 OK */ ProjectMiningPaginatedResponse;
export type MiningQueryTableApiArg = {
  /** Project ID */
  projectId: string;
  /** Table name */
  tableName: string;
  /** Page number */
  page?: number;
  /** Execution ID for pagination, or of a run still going to wait on */
  executionId?: string;
  /** Wait at most this long, then answer 202 and leave the run going */
  waitSeconds?: number;
  /** false skips the total row count */
  count?: boolean;
  /** Query request */
  projectQueryTableRequest: ProjectQueryTableRequest;
};
export type GetApiProjectsByProjectIdTablesAndTableNameFindingsApiResponse =
  /** status 200 OK */ { data: ProjectTableFindingsResponse };
export type GetApiProjectsByProjectIdTablesAndTableNameFindingsApiArg = {
  /** Project ID */
  projectId: string;
  /** Table name */
  tableName: string;
};
export type GetApiWorkspacesByIdProjectsApiResponse =
  /** status 200 OK */ { data: ProjectListProjectsResponse };
export type GetApiWorkspacesByIdProjectsApiArg = {
  /** Workspace ID */
  id: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
  /** Case-insensitive substring of the project name or slug */
  q?: string;
  /** Comma-separated extras to attach to each item. Supported: table_summary (per-project table counts by layer and health, plus the newest refresh) */
  include?: string;
};
export type PostApiWorkspacesByIdProjectsApiResponse =
  /** status 201 Created */ { data: ProjectProjectResponse };
export type PostApiWorkspacesByIdProjectsApiArg = {
  /** Workspace ID */
  id: string;
  /** Project creation request */
  projectCreateProjectRequest: ProjectCreateProjectRequest;
};
export type ProjectTableHealthResponse = TableHealthResponse;
export type ProjectProjectTableSummaryResponse = ProjectTableSummaryResponse;
export type ProjectProjectResponse = ProjectResponse;
export type WorkspaceLeaveResult = LeaveResult;
export type WorkspaceLeaveRequest = {
  new_owner_user_id?: string;
};
export type WorkspaceWorkspaceMemberResponse = WorkspaceMemberResponse;
export type WorkspaceLeavePreview = LeavePreview;
export type WorkspaceListWorkspaceMembersResponse = ListWorkspaceMembersResponse;
export type WorkspaceAddMemberResponse = AddMemberResponse;
export type WorkspaceAddMemberRequest = {
  /** AcceptExtraSeat is an owner's answer to SEAT_NOT_INCLUDED: yes, add this person
    even though the seat is billed. Ignored while the org is within its included seats. */
  accept_extra_seat?: boolean;
  email: string;
  /** Role to assign on invite. Defaults to "member" when empty. */
  role?: "owner" | "admin" | "member" | "readonly";
};
export type WorkspaceMemberIdpSubResponse = MemberIdpSubResponse;
export type WorkspacePendingWorkspaceInvitationResponse = PendingWorkspaceInvitationResponse;
export type WorkspaceUpdateMemberRoleResponse = UpdateMemberRoleResponse;
export type WorkspaceUpdateWorkspaceMemberRoleRequest = {
  role: "owner" | "admin" | "member" | "readonly";
};
export type ProjectRelationshipForeignKey = RelationshipForeignKey;
export type ProjectTableRelationships = TableRelationships;
export type ProjectProjectRelationshipsResponse = ProjectRelationshipsResponse;
export type AdaptersInstructionMetadata = {
  id?: string;
  text?: string;
};
export type AdaptersTableMetadata = {
  /** CoOwned marks a SharedFrom table this project co-owns: its members manage and refresh the
    source that loads it, from the Sources page. */
  co_owned?: boolean;
  columns?: {
    [key: string]: string;
  };
  instructions?: AdaptersInstructionMetadata[];
  is_empty?: boolean;
  /** SharedFrom names the project a data share brings this table in from; empty for own tables. */
  shared_from?: string;
};
export type ProjectMiningPaginatedResponse = MiningPaginatedResponse;
export type ProjectQueryTableRequest = {
  /** Optional: for shared tables, specify the provider database */
  database?: string;
  /** MaxRows caps the rows the query returns; 0 or absent leaves it uncapped. */
  max_rows?: number;
  query?: string;
};
export type ProjectColumnFindings = ColumnFindings;
export type ProjectTableKnowledge = TableKnowledge;
export type ProjectTableFindingsResponse = TableFindingsResponse;
export type ProjectListProjectsResponse = ListProjectsResponse;
export type ProjectCreateProjectRequest = {
  region: string;
  slug: string;
  status: "active" | "inactive" | "pending";
  workspace_id: string;
};
export const {
  useGetApiProjectsByProjectIdQuery,
  useLazyGetApiProjectsByProjectIdQuery,
  useDeleteApiProjectsByProjectIdMutation,
  usePostApiProjectsByProjectIdLeaveMutation,
  useGetApiProjectsByProjectIdLeavePreviewQuery,
  useLazyGetApiProjectsByProjectIdLeavePreviewQuery,
  useGetApiProjectsByProjectIdMembersQuery,
  useLazyGetApiProjectsByProjectIdMembersQuery,
  usePostApiProjectsByProjectIdMembersMutation,
  useProjectGetMembersIdpSubsQuery,
  useLazyProjectGetMembersIdpSubsQuery,
  useGetApiProjectsByProjectIdMembersInvitationsQuery,
  useLazyGetApiProjectsByProjectIdMembersInvitationsQuery,
  useDeleteApiProjectsByProjectIdMembersInvitationsAndInvitationIdMutation,
  useDeleteApiProjectsByProjectIdMembersAndUserIdMutation,
  usePatchApiProjectsByProjectIdMembersAndUserIdRoleMutation,
  useGetApiProjectsByProjectIdRelationshipsQuery,
  useLazyGetApiProjectsByProjectIdRelationshipsQuery,
  useMiningListAvailableTablesQuery,
  useLazyMiningListAvailableTablesQuery,
  useMiningListAvailableTablesWithColumnsQuery,
  useLazyMiningListAvailableTablesWithColumnsQuery,
  useMiningListAvailableTablesWithMetadataQuery,
  useLazyMiningListAvailableTablesWithMetadataQuery,
  useMiningShowTableSchemaQuery,
  useLazyMiningShowTableSchemaQuery,
  useMiningQueryTableMutation,
  useGetApiProjectsByProjectIdTablesAndTableNameFindingsQuery,
  useLazyGetApiProjectsByProjectIdTablesAndTableNameFindingsQuery,
  useGetApiWorkspacesByIdProjectsQuery,
  useLazyGetApiWorkspacesByIdProjectsQuery,
  usePostApiWorkspacesByIdProjectsMutation,
} = injectedRtkApi;
